import * as React from 'react';
import { Button } from '@rtkwlf/ui';
import Icon from '../../../../widgets/Icons';
import {
  CredentialSchema,
  CredentialSecret,
  CredentialStatus,
} from '../../../../types';
import LightTooltip, {
  TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE,
} from '../../../../widgets/LightTooltip';
import { ROUTE_PATH } from '../../../../constants';
import { useRedirectCallback } from '../../../../hooks';

type Props = {
  schema: CredentialSchema;
  secret: CredentialSecret;
  onDelete: (credential: CredentialSecret) => void;
};

export const ColumnAction: React.FunctionComponent<Props> = (props) => {
  const { secret, schema } = props;

  const onEdit = useRedirectCallback(
    `${ROUTE_PATH.SELF_SERVICE.CONNECTED_ACCOUNTS.EDIT}/${secret.uuid}`,
  );

  const onDelete = React.useCallback(() => {
    props.onDelete(secret);
  }, [props, secret]);

  return (
    <div className="column-action-buttons">
      <a
        className="column-action-button pl-0"
        href={schema.setup_guide}
        target="_blank"
        rel="noopener noreferrer"
        data-cy="guide"
      >
        <LightTooltip
          block
          tooltip="View configuration guide"
          delay={TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE}
          placement={'top'}
          size={'lg'}
        >
          <Icon.ICircle />
        </LightTooltip>
      </a>

      <LightTooltip
        block
        tooltip="Edit account"
        delay={TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE}
        placement={'top'}
        size={'lg'}
      >
        <Button
          className="column-action-button"
          onClick={onEdit}
          disabled={secret.status === CredentialStatus.DEACTIVATING}
          data-cy="edit"
          type="link"
        >
          <Icon.Pencil />
        </Button>
      </LightTooltip>

      <LightTooltip
        block
        tooltip="Remove account"
        delay={TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE}
        placement={'top'}
        size={'lg'}
      >
        <Button
          className="column-action-button"
          onClick={onDelete}
          disabled={secret.status === CredentialStatus.DEACTIVATING}
          data-cy="delete"
          type="link"
        >
          <Icon.X />
        </Button>
      </LightTooltip>
    </div>
  );
};
